import { buildCollection, buildProperty } from '@firecms/core';
import { getFirestore, doc, updateDoc, deleteField } from 'firebase/firestore';
import { CollectionSourceProps } from '~/common';
import { ThemeField } from './ThemeField';

export const configsCollection = ({ dataSourceDelegate, firebaseApp }: CollectionSourceProps) =>
    buildCollection({
        name: 'Configs',
        singularName: 'Config',
        id: 'configs',
        path: 'configs',
        group: 'Management',
        icon: 'tune',
        textSearchEnabled: true,
        titleProperty: 'otaCode',
        customId: true,
        callbacks: {
            onPreSave: async ({ values, entityId, previousValues }) => {
                if (firebaseApp && entityId && previousValues) {
                    const db = getFirestore(firebaseApp);
                    const ref = doc(db, 'configs', entityId);
                    const deletions: Record<string, unknown> = {};

                    for (const themeKey of ['devThemeV2', 'productionThemeV2'] as const) {
                        const prevBanners = (previousValues[themeKey] as any)?.Banners ?? {};
                        const nextBanners = (values[themeKey] as any)?.Banners ?? {};
                        for (const bannerKey of Object.keys(prevBanners)) {
                            if (!(bannerKey in nextBanners)) {
                                deletions[`${themeKey}.Banners.${bannerKey}`] = deleteField();
                            }
                        }
                    }

                    if (Object.keys(deletions).length > 0) {
                        await updateDoc(ref, deletions);
                    }
                }

                return { ...values, otaCode: values.otaCode ?? entityId };
            },
        },
        overrides: {
            dataSourceDelegate,
        },
        properties: {
            otaCode: {
                dataType: 'string',
                name: 'OTA Code',
                description: 'Synced from document ID — do not edit directly',
                readOnly: true,
            },
            devThemeV2: buildProperty({
                dataType: 'map',
                name: 'Dev Theme',
                Field: ThemeField,
            }),
            productionThemeV2: buildProperty({
                dataType: 'map',
                name: 'Production Theme',
                Field: ThemeField,
            }),
        },
        propertiesOrder: ['otaCode', 'devThemeV2', 'productionThemeV2'],
    });
